// Tetikleyici kartini Shadow DOM icinde cizer. Musteri sitesinin CSS'i sizamaz.
// Bu dosya babel'dan gecmez: ES2017 uzeri sozdizimi (spread, optional chaining) kullanma.

const HOST_ID = "supsis-trigger-card";
let hostEl = null;
let farewellTimer = null;
let bridgeListener = null;

const STYLES = `
:host { all: initial; }
* { box-sizing: border-box; margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
.mask { position: fixed; inset: 0; background: rgba(0,0,0,.45); z-index: 2147483646; }
.card { position: fixed; max-width: calc(100vw - 32px); display: flex; flex-direction: column; background: #fff; border-radius: 14px; box-shadow: 0 8px 32px rgba(0,0,0,.18); overflow: hidden; z-index: 2147483647; animation: sup-in .22s ease-out; }
.card.fullscreen { inset: 0; border-radius: 0; max-width: none; max-height: none; }
/* Baslik ve butonlar sabit; gorsel + mesaj + kod blogu birlikte tasarsa ortadaki alan kayar */
.head, .actions { flex: 0 0 auto; }
.content { flex: 1 1 auto; min-height: 0; overflow-y: auto; }
@keyframes sup-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; } }
/* Ortalanan kartta inline transform var; giris animasyonu onu ezmesin. */
.card.no-anim { animation: none; }
.head { display: flex; align-items: center; gap: 8px; padding: 12px 14px; border-bottom: 1px solid #eee; }
.avatar { width: 28px; height: 28px; border-radius: 50%; object-fit: cover; flex: 0 0 28px; }
.title { font-size: 14px; font-weight: 600; color: #1f2937; flex: 1; line-height: 1.3; }
.close, .mini { border: 0; background: transparent; cursor: pointer; font-size: 18px; line-height: 1; color: #9ca3af; padding: 2px 4px; }
.close:hover, .mini:hover { color: #374151; }
.mini { font-size: 20px; }
/* Baslik seridi ayni zamanda surukleme tutamagi; butonlar tiklanabilir kalmali. */
.head.draggable { cursor: grab; touch-action: none; user-select: none; }
.head.draggable button { cursor: pointer; }
.card.dragging { transition: none; }
.card.dragging .head.draggable { cursor: grabbing; }
/* Kucultulmus kart: yalnizca baslik seridi kalir, genislik icerige iner. */
.card.minimized { width: auto !important; max-width: min(260px, calc(100vw - 32px)) !important; max-height: none !important; }
.card.minimized .content, .card.minimized .actions { display: none; }
.card.minimized .head { border-bottom: 0; cursor: pointer; }
.card.minimized .title { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
/* Mobilde ayni kart daha az yer kaplasin: boslukar ve gorsel yuksekligi kisilir. */
.card.compact .head { padding: 10px 12px; }
.card.compact .body { padding: 12px; font-size: 13px; }
.card.compact .row { padding: 12px; gap: 10px; }
.card.compact .row .thumb { width: 56px; height: 56px; flex: 0 0 56px; }
.card.compact .actions { gap: 6px; padding: 0 12px 12px; }
.card.compact .btn { padding: 9px 12px; font-size: 13px; }
.card.compact .media.fit-contain { max-height: 150px; }
.card.compact .media.fit-cover { height: 130px; }
/* fit-contain: gorselin tamami gorunur (bosluk kalabilir). fit-cover: kutuyu doldurur (kirpar). */
.media { display: block; width: 100%; background: #f9fafb; }
.media.fit-contain { max-height: 220px; object-fit: contain; }
.media.fit-cover { height: 180px; object-fit: cover; }
.media.linked { cursor: pointer; }
.body { padding: 14px; font-size: 14px; line-height: 1.5; color: #374151; }
.body img { max-width: 100%; height: auto; }
.body p { margin: 0 0 6px; }
.actions { display: flex; flex-direction: column; gap: 8px; padding: 0 14px 14px; }
.btn { width: 100%; padding: 10px 12px; border-radius: 9px; font-size: 14px; font-weight: 500; cursor: pointer; border: 1px solid transparent; transition: filter .15s; }
.btn:hover { filter: brightness(.94); }
.btn.primary { background: var(--accent, #2563eb); color: #fff; }
.btn.secondary { background: #fff; color: #374151; border-color: #d1d5db; }
.card.has-bg { background-size: cover; background-position: center; }
/* Butonlar da katmanlanmali: ::before yoksa uzerlerine binip tiklamayi yutuyor. */
.card.has-bg .head, .card.has-bg .content, .card.has-bg .actions { position: relative; z-index: 1; }
.card.has-bg .title, .card.has-bg .body { color: #fff; }
.card.has-bg::before { content: ""; position: absolute; inset: 0; background: linear-gradient(180deg, rgba(0,0,0,.25) 0%, rgba(0,0,0,.72) 100%); }
.row { display: flex; gap: 12px; padding: 14px; align-items: flex-start; }
.row .thumb { width: 72px; height: 72px; border-radius: 8px; object-fit: cover; flex: 0 0 72px; background: #f9fafb; }
.row .thumb.fit-contain { object-fit: contain; }
.row .thumb.linked { cursor: pointer; }
.row .body { padding: 0; flex: 1; }
.codeframe { display: block; width: 100%; border: 0; }
.farewell { padding: 14px; font-size: 14px; color: #6b7280; text-align: center; }
`;

const SIZE_PX = { narrow: 320, medium: 420, wide: 560 };

function isSafeUrl(url) {
    return typeof url === "string" && /^https?:\/\//i.test(url);
}

// Kullanicinin HTML/JS'i sandbox iframe'de calisir. allow-same-origin VERILMEZ:
// opak origin, yani parent DOM, cerez ve localStorage erisimi yok.
function buildSrcdoc(html) {
    const bridge =
        "<script>(function(){window.supsis={" +
        "startChat:function(t){parent.postMessage({__supsisTrigger:1,type:'startChat',text:String(t||'')},'*')}," +
        "close:function(){parent.postMessage({__supsisTrigger:1,type:'close'},'*')}," +
        "openUrl:function(u,t){parent.postMessage({__supsisTrigger:1,type:'openUrl',url:String(u||''),target:t==='_self'?'_self':'_blank'},'*')}" +
        "};})();<\/script>";
    return (
        "<!doctype html><html><head><meta charset='utf-8'>" +
        "<style>html,body{margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}</style>" +
        bridge +
        "</head><body>" + html + "</body></html>"
    );
}

// Gorsel elemani; className yerlesime gore "media" ya da "thumb".
function buildImage(payload, className) {
    const img = document.createElement("img");
    const fit = payload.image.fit === "cover" ? "cover" : "contain";
    img.className = className + " fit-" + fit;
    img.src = payload.image.url;
    img.alt = "";
    img.addEventListener("error", () => img.remove());
    if (isSafeUrl(payload.image.link)) {
        img.classList.add("linked");
        img.addEventListener("click", () => window.open(payload.image.link, "_blank"));
    }
    return img;
}

// Kirilimlar: <=768 mobil, 769-1024 tablet, >1024 masaustu.
const TABLET_MAX_WIDTH = 1024;

function isMobileViewport() {
    return !!window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
}

function isTabletViewport() {
    return (
        !!window.matchMedia &&
        window.matchMedia("(min-width: 769px) and (max-width: " + TABLET_MAX_WIDTH + "px)").matches
    );
}

// Yerlesim profili: kayitta karsiligi yoksa readPlacement masaustune duser.
function readProfileName() {
    if (isMobileViewport()) return "mobile";
    if (isTabletViewport()) return "tablet";
    return "desktop";
}

// Kayittaki yerlesim yoksa bugunku davranisa duser.
function readPlacement(payload) {
    const display = payload.display || {};
    const profile = readProfileName();
    let p = display[profile] || null;
    // Tablet kayitli degilse masaustune duser: eski tetikleyicilerin gorunumu degismez.
    if (!p && profile === "tablet") p = display.desktop || null;
    if (!p || !p.anchor) {
        return payload.position === "center"
            ? { anchor: "center", offsetX: 0, offsetY: 0, size: "narrow" }
            : { anchor: "bottom-right", offsetX: 20, offsetY: 96, size: "narrow" };
    }
    return {
        anchor: p.anchor,
        offsetX: typeof p.offsetX === "number" ? p.offsetX : 0,
        offsetY: typeof p.offsetY === "number" ? p.offsetY : 0,
        size: p.size || "narrow",
    };
}

// Sohbet baloncugunun host belgedeki olcusu. Kart onun ustune binmesin diye okunur.
const LAUNCHER_GAP = 12;

function launcherRect() {
    try {
        const el = document.getElementById("ls-openButton");
        if (!el) return null;
        const r = el.getBoundingClientRect();
        if (!r || (!r.width && !r.height)) return null;
        return r;
    } catch (e) {
        return null;
    }
}

// Kartin yatayda nereye dusecegini onceden hesaplar: baloncukla kesisiyor mu?
function horizontalRange(anchor, offsetX, width, vw) {
    if (anchor.indexOf("right") !== -1) {
        const right = vw - offsetX;
        return { left: right - width, right: right };
    }
    if (anchor.indexOf("left") !== -1) return { left: offsetX, right: offsetX + width };
    const left = (vw - width) / 2;
    return { left: left, right: left + width };
}

// Alt kenara yaslanan kart baloncugun ustune biniyorsa yukari itilir.
// Sabit bir offset yerine baloncugun gercek yuksekligi olculuyor: tema, boyut
// ve kenar boslugu degistiginde de dogru kaliyor.
function bottomOffsetClearingLauncher(anchor, offsetX, offsetY, width) {
    const r = launcherRect();
    if (!r) return offsetY;
    const vw = window.innerWidth || 360;
    const vh = window.innerHeight || 640;
    const span = horizontalRange(anchor, offsetX, width, vw);
    const kesisiyor = !(span.right < r.left || span.left > r.right);
    if (!kesisiyor) return offsetY;
    const gerekli = vh - r.top + LAUNCHER_GAP;
    return offsetY > gerekli ? offsetY : gerekli;
}

// anchor'i inline stile cevirir. 9 nokta x 2 profil icin sinif uretmek yerine hesaplanir.
function applyPlacement(card, placement, mobile) {
    const a = placement.anchor;
    const x = placement.offsetX;
    const y = placement.offsetY;

    if (placement.size === "full" && mobile) {
        card.className += " fullscreen";
        return;
    }
    let genislik = SIZE_PX[placement.size] || 320;
    card.style.width = genislik + "px";
    if (placement.size === "full") {
        genislik = 900;
        card.style.width = "min(900px, calc(100vw - 32px))";
    }
    // Mobilde genis boyutlar ekrani boydan boya kapliyordu; kart daralir, tasan
    // metin max-width ile zaten sinirli.
    if (mobile) {
        if (genislik > 320) genislik = 320;
        card.style.width = "min(" + genislik + "px, calc(100vw - 24px))";
    }
    if (mobile) card.className += " compact";

    // "middle-*" ve "center" dikeyde ortaya duser: indexOf("top"/"bottom") sifir dondurmez.
    let tx = "";
    if (a.indexOf("top") === 0) card.style.top = y + "px";
    else if (a.indexOf("bottom") === 0) card.style.bottom = bottomOffsetClearingLauncher(a, x, y, genislik) + "px";
    else {
        card.style.top = "50%";
        tx = "translateY(-50%)";
    }

    if (a.indexOf("left") !== -1) card.style.left = x + "px";
    else if (a.indexOf("right") !== -1) card.style.right = x + "px";
    else {
        card.style.left = "50%";
        tx = tx ? "translate(-50%, -50%)" : "translateX(-50%)";
    }

    if (tx) {
        card.style.transform = tx;
        card.className += " no-anim";
    }

    // Gorsel + kod blogu birlikteyken kart ekrani asabiliyor; fixed oldugu icin tasan kisim
    // ulasilamaz kaliyordu. Ekranda kalan yere gore sinirla, icerik kendi icinde kaysin.
    const vh = window.innerHeight || 800;
    const vertical = a.indexOf("top") === 0 || a.indexOf("bottom") === 0;
    let maxH = vertical ? vh - y - 24 : vh - 32;
    if (maxH < 200) maxH = 200;
    card.style.maxHeight = maxH + "px";
}

// --- Surukleme ------------------------------------------------------------
// Kart konumu sekme boyunca hatirlanir: ziyaretci her tetikleyicide yeniden
// tasimak zorunda kalmasin, ama kalici ayar da olmasin.
function posKey(payload) {
    return "supsis-trigger-pos-" + ((payload && (payload._id || payload.id)) || "default");
}

function readStoredPos(payload) {
    try {
        const raw = window.sessionStorage.getItem(posKey(payload));
        if (!raw) return null;
        const p = JSON.parse(raw);
        if (!p || typeof p.left !== "number" || typeof p.top !== "number") return null;
        return p;
    } catch (e) {
        return null;
    }
}

function writeStoredPos(payload, pos) {
    try {
        window.sessionStorage.setItem(posKey(payload), JSON.stringify(pos));
    } catch (e) {
        /* gizli sekmede depolama kapali olabilir */
    }
}

// Kart ekran disina tasmasin; pencere kucultulunce saklanan konum da kirpilir.
function clampToViewport(card, left, top) {
    const w = card.offsetWidth || 280;
    const h = card.offsetHeight || 120;
    const vw = window.innerWidth || 360;
    const vh = window.innerHeight || 640;
    const maxLeft = vw - w > 0 ? vw - w : 0;
    const maxTop = vh - h > 0 ? vh - h : 0;
    return {
        left: left < 0 ? 0 : left > maxLeft ? maxLeft : left,
        top: top < 0 ? 0 : top > maxTop ? maxTop : top,
    };
}

// Yerlesim right/bottom/transform ile kurulmus olabilir; surukleme icin
// olculen kutuya bakip left/top'a cevrilir.
function switchToAbsolute(card, left, top) {
    const pos = clampToViewport(card, left, top);
    card.style.right = "auto";
    card.style.bottom = "auto";
    card.style.transform = "none";
    card.style.left = pos.left + "px";
    card.style.top = pos.top + "px";
    return pos;
}

function enableDrag(card, head, payload) {
    let baslangic = null;

    const tut = function (e) {
        // Kapat/kucult dugmelerinde surukleme baslamasin.
        if (e.target && e.target.closest && e.target.closest("button")) return;
        const r = card.getBoundingClientRect();
        card.__supsisDragged = false;
        baslangic = { x: e.clientX, y: e.clientY, left: r.left, top: r.top };
        switchToAbsolute(card, r.left, r.top);
        card.className += " dragging";
        try {
            head.setPointerCapture(e.pointerId);
        } catch (err) {
            /* eski tarayici */
        }
        e.preventDefault();
    };

    const surukle = function (e) {
        if (!baslangic) return;
        const dx = e.clientX - baslangic.x;
        const dy = e.clientY - baslangic.y;
        if (dx > 4 || dx < -4 || dy > 4 || dy < -4) card.__supsisDragged = true;
        switchToAbsolute(card, baslangic.left + dx, baslangic.top + dy);
        e.preventDefault();
    };

    const birak = function (e) {
        if (!baslangic) return;
        baslangic = null;
        card.className = card.className.replace(/\s*dragging/g, "");
        const r = card.getBoundingClientRect();
        writeStoredPos(payload, { left: r.left, top: r.top });
        try {
            head.releasePointerCapture(e.pointerId);
        } catch (err) {
            /* yakalama zaten dusmus olabilir */
        }
    };

    head.className += " draggable";
    head.addEventListener("pointerdown", tut);
    head.addEventListener("pointermove", surukle);
    head.addEventListener("pointerup", birak);
    head.addEventListener("pointercancel", birak);
}

export function destroyTriggerCard() {
    if (bridgeListener) {
        window.removeEventListener("message", bridgeListener);
        bridgeListener = null;
    }
    if (farewellTimer) {
        clearTimeout(farewellTimer);
        farewellTimer = null;
    }
    if (hostEl && hostEl.parentNode) hostEl.parentNode.removeChild(hostEl);
    hostEl = null;
}

export function renderTriggerCard(payload, handlers) {
    try {
        destroyTriggerCard();

        hostEl = document.createElement("div");
        hostEl.id = HOST_ID;
        const root = hostEl.attachShadow({ mode: "open" });

        const style = document.createElement("style");
        style.textContent = STYLES;
        root.appendChild(style);

        const card = document.createElement("div");
        const placement = readPlacement(payload);
        const mobile = isMobileViewport();
        card.className = "card";
        applyPlacement(card, placement, mobile);
        if (payload.accentColor) card.style.setProperty("--accent", payload.accentColor);

        if (placement.anchor === "center") {
            const mask = document.createElement("div");
            mask.className = "mask";
            mask.addEventListener("click", () => handlers.onClose());
            root.appendChild(mask);
        }

        // Baslik seridi
        const head = document.createElement("div");
        head.className = "head";
        if (payload.showAvatar && payload.avatarUrl) {
            const av = document.createElement("img");
            av.className = "avatar";
            av.src = payload.avatarUrl;
            av.addEventListener("error", () => av.remove());
            head.appendChild(av);
        }
        const title = document.createElement("div");
        title.className = "title";
        title.textContent = payload.title || "";
        head.appendChild(title);
        // Kucult: kart kapanmadan yalnizca baslik seridine iner, tekrar acilir.
        const mini = document.createElement("button");
        mini.className = "mini";
        mini.type = "button";
        mini.innerHTML = "&minus;";
        const setMinimized = (kucuk) => {
            card.className = card.className.replace(/\s*minimized/g, "");
            if (kucuk) card.className += " minimized";
            mini.innerHTML = kucuk ? "&plus;" : "&minus;";
        };
        mini.addEventListener("click", () => setMinimized(card.className.indexOf("minimized") === -1));
        // Kucukken baslige dokunmak geri acar; surukleme baslamadiysa tiklama sayilir.
        title.addEventListener("click", () => {
            // Surukleyip birakma da click uretiyor; yalnizca gercek dokunusta ac.
            if (card.__supsisDragged) return;
            if (card.className.indexOf("minimized") !== -1) setMinimized(false);
        });
        head.appendChild(mini);
        const close = document.createElement("button");
        close.className = "close";
        close.type = "button";
        close.innerHTML = "&times;";
        close.addEventListener("click", () => handlers.onClose());
        head.appendChild(close);
        card.appendChild(head);
        // Tam ekran kartta tasima/kucultme anlamsiz.
        if (card.className.indexOf("fullscreen") === -1) enableDrag(card, head, payload);

        // Kayan orta alan: gorsel, mesaj ve kod blogu burada durur.
        const content = document.createElement("div");
        content.className = "content";
        card.appendChild(content);

        // Mesaj
        let bodyEl = null;
        if (payload.html) {
            bodyEl = document.createElement("div");
            bodyEl.className = "body";
            bodyEl.innerHTML = payload.html;
        }

        // Gorsel yerlesimi: top | below | left | background
        const imagePlacement = (payload.image && payload.image.placement) || "top";
        const hasImage = !!(payload.image && payload.image.url);

        if (hasImage && imagePlacement === "background") {
            card.className += " has-bg";
            card.style.backgroundImage = 'url("' + payload.image.url.replace(/"/g, "%22") + '")';
            if (bodyEl) content.appendChild(bodyEl);
        } else if (hasImage && imagePlacement === "left") {
            const rowEl = document.createElement("div");
            rowEl.className = "row";
            rowEl.appendChild(buildImage(payload, "thumb"));
            if (bodyEl) rowEl.appendChild(bodyEl);
            content.appendChild(rowEl);
        } else if (hasImage && imagePlacement === "below") {
            if (bodyEl) content.appendChild(bodyEl);
            content.appendChild(buildImage(payload, "media"));
        } else {
            if (hasImage) content.appendChild(buildImage(payload, "media"));
            if (bodyEl) content.appendChild(bodyEl);
        }

        // Ozel kod blogu
        let codeFrame = null;
        const cb = payload.codeBlock;
        if (cb && cb.enabled && cb.html) {
            codeFrame = document.createElement("iframe");
            codeFrame.className = "codeframe";
            codeFrame.setAttribute("sandbox", "allow-scripts");
            codeFrame.setAttribute("srcdoc", buildSrcdoc(cb.html));
            let h = typeof cb.height === "number" ? cb.height : 240;
            if (h < 80) h = 80;
            if (h > 600) h = 600;
            codeFrame.style.height = h + "px";
            content.appendChild(codeFrame);
        }

        if (codeFrame) {
            bridgeListener = function (e) {
                if (!codeFrame || e.source !== codeFrame.contentWindow) return;
                const d = e.data;
                if (!d || d.__supsisTrigger !== 1) return;
                if (d.type === "close") return handlers.onClose();
                if (d.type === "startChat") return handlers.onCodeAction({ type: "startChat", text: d.text });
                if (d.type === "openUrl") return handlers.onCodeAction({ type: "openUrl", url: d.url, target: d.target });
            };
            window.addEventListener("message", bridgeListener);
        }

        // Butonlar
        const buttons = Array.isArray(payload.buttons) ? payload.buttons : [];
        if (buttons.length) {
            const actions = document.createElement("div");
            actions.className = "actions";
            buttons.forEach((b) => {
                // Guvensiz url'li buton hic cizilmez.
                if (b.action === "open_url" && !isSafeUrl(b.url)) return;
                const btn = document.createElement("button");
                btn.type = "button";
                btn.className = `btn ${b.style === "primary" ? "primary" : "secondary"}`;
                btn.textContent = b.text || "";
                btn.addEventListener("click", () => handlers.onButtonClick(b));
                actions.appendChild(btn);
            });
            card.appendChild(actions);
        }

        root.appendChild(card);
        document.body.appendChild(hostEl);

        // Ziyaretcinin bu sekmede tasidigi konum varsa yerlesimin uzerine gecer.
        const saklanan = readStoredPos(payload);
        if (saklanan && card.className.indexOf("fullscreen") === -1) {
            switchToAbsolute(card, saklanan.left, saklanan.top);
        }
    } catch (e) {
        // Kart cizilemezse musteri sitesi etkilenmesin.
        if (window.console && console.error) console.error("supsis triggerCard", e);
        destroyTriggerCard();
    }
}

// Veda metnini gosterip karti kapatir.
export function showFarewell(text, onDone) {
    if (!hostEl || !hostEl.shadowRoot) return onDone();
    const card = hostEl.shadowRoot.querySelector(".card");
    if (!card) return onDone();
    card.innerHTML = `<div class="farewell"></div>`;
    card.querySelector(".farewell").textContent = text;
    farewellTimer = setTimeout(onDone, 3000);
}



//////////////////
// WEBPACK FOOTER
// ./static/src/triggerCard.js
// module id = null
// module chunks = 